import React, {Component} from 'react';
//import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
//import FolderOpenIcon from '@material-ui/icons/FolderOpen';
//import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import UpBanner from '../../../TempWebPage/UpBanner/UpBanner'
//import BGImage from '../../../../Utilities/default.jpg'
import {Prompt} from 'react-router-dom'
import EditContent from './EditContent/EditContent'
import ContentPreview from './ContentPreview'
//import StaticPageCheck from './StaticPageCheck'
import {server_ip} from '../../../../ipAddress'


const wStyles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    scrollContent1:{
        height:2000,
        width:200,
        backgroundColor:"#e6f542",
    },
    scrollContent2:{
        height:2000,
        width:200,
        backgroundColor:"#2e82ff",
    },
    scrollContainer:{
        //backgroundImage: `url(${BGImage})`,
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundSize: "cover",
        position:"relative",
        width:"100%",
       // height:"1000px",
        overflow:"auto"
    },
    fixedUpHeader: {
        position:"sticky"
    },
    rightTopBoxArea:{
        position: "absolute",
        right: 2,
        top: 2,
        display: "flex",
    },
    textLinkLeft:{
        float:"left",
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
        },
    },

    textLinkRight:{
        float:"right",
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
        },
    },
    rightTopBox: {
        width:20,
        height:20,
        fontFamily: "Arial, Helvetica, sans-serif",
        cursor: "pointer",
        textAlign: "center",
        borderRadius: 5,
        backgroundColor:"#e6e6e6",
        color: "gray",
        '&:hover':{
            backgroundColor: "gray",
            color: "white",
        }
    },
    titleArea: {
        fontSize: 40,
        fontFamily: "Microsoft JhengHei",
    },
    input: {
        display: "none",
    },
});

class StaticPageCreateBody extends Component {
    constructor(props) {
        super(props)
        this.state = {
            StaticPage_SysID:null,
            editComplete:false,
            showContentPreview:false,  
            showContentCheck:false,
            fullScreen:false,
            bodySize:null,
            bodyHeight:null,
            compositionContainers:[]
        }
        this.openTempFile = React.createRef()   
        this.editContentRef = React.createRef()  
    }

    componentDidMount(){
        this.fetchStaticPageInfoFromAPI()
    }

    componentDidUpdate(){
   
    }

    componentWillUnmount(){
        
    }

    getEventCreatedDate = (cDate) =>{
        let tYear = this.addZeroFirstAndToString(cDate.getFullYear())
        let tMonth = this.addZeroFirstAndToString(cDate.getMonth()+1)
        let tDate = this.addZeroFirstAndToString(cDate.getDate())
        let tHour = this.addZeroFirstAndToString(cDate.getHours())
        let tMinute = this.addZeroFirstAndToString(cDate.getMinutes())
        return tYear+tMonth+tDate+tHour+tMinute
    }

    addZeroFirstAndToString = (num) =>{
        let output = ''
        if(num<10)
        {
          output = '0'+num
        }
        else
        {
          output = String(num)
        }
        return output
    }

    fetchStaticPageInfoFromAPI = async()=>{
        console.log("fetchStaticPageInfoFromAPI...")
        let StaticPage_SysID = this.props.match.params.StaticPage_SysID
        console.log("StaticPage_SysID : ",StaticPage_SysID )
        let msg = await fetch(server_ip+'/api/staticPage/get/Page/'+StaticPage_SysID)
        console.log(msg)
        
        if(msg.ok)
        {
            let output = await msg.json()
            console.log(output)
            console.log("A1")
            
            if(output[0])
            {
                console.log("A1-1")
                this.setState({
                    StaticPage_SysID:StaticPage_SysID,
                    compositionContainers:output[0].Temp_StaticPage_CompositionSettings
                })
            }
            else
            {
                console.log("A1-2")
                this.setState({
                    StaticPage_SysID:StaticPage_SysID,
                    compositionContainers:[]
                })
            }
        }
        else if(!msg.ok)
        {
            console.log("A2")
            this.setState({
                StaticPage_SysID:StaticPage_SysID,
                compositionContainers:[]
            })
        }  
    }

    openFileLoadingDialog = () => {
        this.openTempFile.current.click()
    }

    fullScreenBoxOnClick = (e) => {
        e.stopPropagation()
        this.setState(prevState=>({
            fullScreen:!prevState.fullScreen
        }))
    }

    previewToggle=()=>{
        this.setState({
            showContentPreview: !this.state.showContentPreview
        })
    }


    getEventContent=(msg)=>{
        console.log("getEventContent...")
        if(msg.editFinish)
        {
            console.log("A1")
            this.setState({
                compositionContainers:msg.compositionContainers,
                bodySize:msg.bodySize,
                bodyHeight:msg.bodyHeight
            },()=>{
                this.postProcedure()
            })
        }
        else
        {
            console.log("A2")
            if(this.state.compositionContainers !== msg.compositionContainers || this.state.bodySize !== msg.bodySize)
            {
                console.log("A2-1")
                this.setState({
                    compositionContainers:msg.compositionContainers,
                    bodySize:msg.bodySize,
                    bodyHeight:msg.bodyHeight,
                    showContentPreview:true,  
                })
            }
            else if(this.state.compositionContainers === null)
            {
                console.log("A2-2")
                this.setState({
                    compositionContainers:msg.compositionContainers,
                    bodySize:msg.bodySize,
                    bodyHeight:msg.bodyHeight,
                    showContentPreview:true,
                })
            }
        }
    }


    showAbstractAreaOrContentArea=()=>{
        if(this.state.showContentPreview)
        {
            return <ContentPreview compositionContainers={this.state.compositionContainers} bodySize={this.state.bodySize} bodyHeight={this.state.bodyHeight} previewToggle={this.previewToggle}/>
        }
        else
        { 
            
            return <EditContent ref={this.editContentRef} fullScreen={this.state.fullScreen} eventContent={this.state.compositionContainers} getEventContent={this.getEventContent}/>
            
            //return <StaticPageCheck fieldCheck={this.allFieldsCheck()} getEventDurationDate={this.getEventDurationDate} />          
        }
    }

    
    compositionContainersCheck=()=>{
        let compositionContainersCheckResult = true
        if(this.state.compositionContainers)
        {
            if(this.state.compositionContainers.length === 0)
            {
                compositionContainersCheckResult = false
            }
            else
            {
                this.state.compositionContainers.forEach((composition)=>{
                    if(composition.type === "image")
                    {
                        if(!composition.imageAttributes)
                        {
                            compositionContainersCheckResult = false
                        }
                        else
                        {
                            if(!composition.imageAttributes.imageUrl)
                            {
                                compositionContainersCheckResult = false
                            }
                        }
                    }
                    else if(composition.type === "text")
                    {
                        if(!composition.textAttributes)
                        {
                            compositionContainersCheckResult = false
                        }
                    }
                })
            }
        }
        else
        {
            compositionContainersCheckResult = false
        }
        
        return compositionContainersCheckResult
    }

    callEditContentToFinishEdit=()=>{
        this.editContentRef.current.sendCompositionContainersBack(true)
    }

    callEditCotentToPreview=()=>{
        this.editContentRef.current.sendCompositionContainersBack(false)
    }

    postProcedure=()=>{
        
        let check = this.compositionContainersCheck()
        if(check)
        {
            console.log("check success !")
            this.postStaticPage()
        }
        else
        {
            console.log("check failure !")
        }
    }


    postStaticPage=async()=>{

        let compositionImagesPromises = new Promise((resolve,reject)=>{
            let compositionImages = this.state.compositionContainers.filter((compositionContainer)=>{                    
                if(compositionContainer.type === "image")
                {
                    let urlPrefix = compositionContainer.imageAttributes.imageUrl.substr(0,4)
                    if(urlPrefix === "blob")
                    {
                        return true
                    }
                    else
                    {
                        return false
                    }
                }
                else
                {
                    return false
                }
            }).map(async(compositionContainer)=>{
                console.log("A7")

                let blobC = await fetch(compositionContainer.imageAttributes.imageUrl).then(r=>r.blob())
                let fileItem = {
                    file:blobC,
                    imageID:compositionContainer.conID
                }
                return fileItem
            })
            resolve(Promise.all(compositionImages))
        })



        let compositionJsonStringfy = new Promise((resolve,reject)=>{
            let myJson = JSON.stringify(this.state.compositionContainers)
            resolve(myJson)
        })

        Promise.all([compositionImagesPromises,compositionJsonStringfy]).then(async(promiseArray)=>{
            let formData = new FormData()     
            console.log(promiseArray)
            promiseArray[0].forEach(file=>{
                formData.append("staticPageCompositionImages", file.file, file.imageID+".jpeg")
            })
            formData.append("staticPageCompositionSettingArray",promiseArray[1])
            formData.append("staticPage_SysID", this.state.StaticPage_SysID)

            let msg = await fetch(server_ip+'/api/staticPage/post/StaticPage', {
                body:formData,
                method:"post"
            })
      
            let output = await msg
            console.log(output)
            if(output.statusText === "OK")
            {
                this.setState({
                    editComplete:true
                },()=>{
                    this.props.history.push("/StaticPageManagement/Default")
                })
            }
        })
    }

    cancelEvent=()=>{
        console.log("cancelEvent...")
        this.props.history.push("/StaticPageManagement/Default")
    }

    getEditModeTitle=()=>{
        return "編輯靜態頁面 : 識別號 "+this.state.StaticPage_SysID
    }


    render(){
        const {classes} = this.props;


        let parentFullScreen = {
            width:'100vw',
            height:'100vh',
            position:'fixed',
            left:'0',
            top:'0',
            zIndex:'2000',
            backgroundColor:'#c3c3c3'   
        }

        let parentNotFullScreen = {
            backgroundColor:'#c3c3c3',
            height:'80vh'
        }

        let childFullScreen = {
            position:"absolute",
            width:"100%",
            height:"100%",
            overflow:"scroll"
        }

        let childNotFullScreen = {
            flexDirection:"column",
            display:"flex"
        }

        let headerFullScreen = {
            position:"fixed",
            zIndex:200,
            backgroundColor:"white",
            width:"100%"
        }

        let headerNotFullScreen = {
            top:"0px",
            position:"sticky",
            zIndex:200,
            backgroundColor:"white",
            width:"100%"
        }

        let maskNotFullScreen = {
            top:"95px",
            backgroundColor:"white",
            zIndex:"150",
            width:"100%",
            height:"20px",
            position:"fixed"
        }

        let fullScreenSymbol = "☐"
        let notFullScreenSymbol = "_"

        return (
            <main className={classes.content}>
                {this.state.editComplete? null:<Prompt message={"將離開編輯頁面，未儲存之資料將遺失! 您確定要離開此頁面嗎?"}/>}
                <div className={classes.appBarSpacer} />
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>  
                                <div style={this.state.fullScreen? parentFullScreen:parentNotFullScreen}>
                                <div style={this.state.fullScreen? childFullScreen:childNotFullScreen}> 
                                    <div className={classes.fixedUpHeader} style={this.state.fullScreen? headerFullScreen:headerNotFullScreen}>
                                        <div className ={classes.rightTopBoxArea}>
                                            <div className = {classes.rightTopBox} onClick={this.fullScreenBoxOnClick}>{this.state.fullScreen? notFullScreenSymbol:fullScreenSymbol}</div>
                                        </div>
                                        <div> 
                                            <div className={classes.titleArea}>{this.getEditModeTitle()}</div>  
                                            <input className={classes.input} type={"file"} ref={this.openTempFile}/>   
                                            <Button className={classes.textLinkRight} startIcon={<DeleteIcon />} onClick={this.cancelEvent}>
                                                結束編輯
                                            </Button>
                                            <Button className={classes.textLinkRight} startIcon={<LocalPrintshopIcon />} >
                                                輸出頁面
                                            </Button>  
                                            <Button className={classes.textLinkRight} startIcon={<DesktopWindowsIcon />} onClick={this.callEditCotentToPreview}>
                                                頁面預覽
                                            </Button>
                                            <Button className={classes.textLinkRight} startIcon={<DesktopWindowsIcon />} onClick={this.callEditContentToFinishEdit}>
                                                完成上傳
                                            </Button>
                                        </div>
                                        {this.state.editingStage === 3 ? null :<div className={"UpHeader"}><UpBanner /><div className={"StaticPageBanner"}></div></div>}
                                    </div>
                                    <div style={maskNotFullScreen}/> 
                                    {this.showAbstractAreaOrContentArea()}
                                </div>
                                </div>
                            </Paper>                
                        </Grid>
                    </Grid>
                </Container>
            </main>
        )  
    }
}

export default withStyles(wStyles)(StaticPageCreateBody)